import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useGetTranslations } from '~/composables/useGetTranslations';
import { useSegment } from '~/composables/_next/useSegment';
import { cacheControl } from '~/helpers/cacheControl';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
export default defineComponent({
  components: {
    BaseBreadcrumbs: function BaseBreadcrumbs() {
      return import('~/components/Layout/BaseBreadcrumbs.vue');
    },
    BaseSingleBreadcrumb: function BaseSingleBreadcrumb() {
      return import('~/components/Layout/BaseSingleBreadcrumb.vue');
    }
  },
  middleware: [cacheControl('public, s-maxage=7200, stale-while-revalidate=3600, stale-if-error=3600') // 2 hours cache and 1 hour stale
  ],
  tracking: {
    category: TrackingPageCategory.CONTACT
  },
  setup: function setup() {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR;
    var breadcrumbs = computed(function () {
      return [{
        link: app.localePath({
          name: 'index'
        }),
        text: translate('utils.homeBreadcrumbs')
      }, {
        link: app.localePath('/info/base-de-connaissance'),
        text: translate('faq.breadcrumbsFaqPage')
      }];
    });
    onMounted(function () {
      setDynamicYieldContext('OTHER', ['FAQ_Page']);
      window.scrollTo(0, 0);

      // TODO: Remove after Nuxt 3 migration
      var _useSegment = useSegment(),
        analytics = _useSegment.analytics;
      var route = useRoute();
      analytics.page(TrackingPageCategory.CONTACT, PageTypes.CONTACT, {
        path: route.fullPath
      });
    });
    setDynamicYieldContextSSR('OTHER', ['FAQ_Page']);
    return {
      breadcrumbs: breadcrumbs,
      translate: translate,
      isMobile: isMobile
    };
  }
});